import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import './style.scss';

const Slider = ({ handleStart }) => (
  <div className="banner">
    <div className="description">
      <h1 className="typing-text">Hãy bắt đầu định hướng cho tương lai ngay nào.</h1>
      <h6 className="sub text-center">Công cụ định hướng nghề nghiệp trực tuyến đã giúp đỡ hàng ngàn sinh viên Văn Lang</h6>
      <p className="text-center start-button-block">
        <Button onClick={handleStart} className="bounce" variant="success">Bắt đầu ngay</Button>
      </p>
    </div>
  </div>
);

Slider.propTypes = {
  handleStart: PropTypes.func.isRequired
};

export default Slider;
